window.$ = window.jQuery = require('jquery');

import { Swiper } from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {ScrollToPlugin} from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

require('./web_function')

$(function () {

    let target = $('meta[name="target"]').attr('content')

    if(target){

        switch (target) {
            case 'how-to-use':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-3", offsetY: 0 } });
                break;

            case 'how-to-clean':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-5", offsetY: 0 } });
                break;

            case 'sales-channels':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-7", offsetY: 0 } });
                break;

            case 'spare-parts':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-6", offsetY: 0 } });
                break;

            case 'download':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-8", offsetY: 0 } });
                break;
        }
    }

    let swiper = new Swiper("#rd-product-photo-swiper2", {
        slidesPerView: 3,
        spaceBetween: 10,
        direction: "horizontal",
        breakpoints: {
            768: {
                spaceBetween: 20,
                slidesPerView: 5,
                direction: "vertical",
            }
        }
    });

    new Swiper("#rd-product-photo-swiper1", {
        thumbs: {
            swiper: swiper,
        },
        navigation: {
            nextEl: '#rd-product-photo-swiper1-next',
            prevEl: '#rd-product-photo-swiper1-prev',
        },
        on: {
            init: function () {
                $('#rd-product-photo-swiper1-pagination').text('1/'+$('.rd-product-photo-box').length)
            },
            slideChange: function (swiper) {

                $('.rd-product-photo-box').removeClass('now').eq(swiper.realIndex).addClass('now')
                $('#rd-product-photo-swiper1-pagination').text((swiper.realIndex+1)+'/'+$('.rd-product-photo-box').length)
            },
        }
    });

    changeLogoColor()
})

function changeLogoColor() {

    ScrollTrigger.create({
        trigger: "#rd-section-5",
        start: "top top",
        markers:false,
        onEnter: function () {
            switchHeaderBlue(false)
        },
        onEnterBack: function () {
            switchHeaderBlue(false)
        },
        onLeave: function () {
            switchHeaderBlue(true)
        },
        onLeaveBack: function () {
            switchHeaderBlue(true)
        }
    });

}
